/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import * as yup from 'yup'
import { Field } from 'react-trazo-forms/dist/FormField'

import { Values} from 'react-trazo-forms'
import { i18n } from '../../../../providers/Locale/localeProvider'
import { regionOptions, countryOptions, getValue, messages } from '../../../../helpers/forms'

// Options
const AccepNewsletter = () => ([
  { key: '1', value: '1', label:'Acepto recibir correos de Purina' }
])


const genderOptions = () => ([
  { key: 'male', value: 'Masculino', label: i18n._('Masculino') },
  { key: 'female', value: 'Femenino', label: i18n._('Femenino') },
])

const ageOptions = () => ([
  { key: '18 a 25 años', value: '18 a 25 años', label: i18n._('18 a 25 años') },
  { key: '26 a 40 años', value: '26 a 40 años', label: i18n._('26 a 40 años') },
  { key: '41 a 65 años', value: '41 a 65 años', label: i18n._('41 a 65 años') },
  { key: 'Mayor a 65 años', value: 'Mayor a 65 años', label: i18n._('Mayor a 65 años') },
])

const BasicOptions = () => ([
  { key: 'PAGADO PARTICULAR', value: 'PAGADO PARTICULAR', label: 'PAGADO PARTICULAR' },
  { key: 'ORIZON', value: 'ORIZON', label: 'ORIZON' },
  { key: 'DRAGPHARMA', value: 'DRAGPHARMA', label: 'DRAGPHARMA' },
  { key: 'ZOETIS', value: 'ZOETIS', label: 'ZOETIS' },
  { key: 'AGROVET', value: 'AGROVET', label: 'AGROVET' },
  { key: 'LUDIPEK', value: 'LUDIPEK', label: 'LUDIPEK' },
  { key: 'MONGE PROA', value: 'MONGE PROA', label: 'MONGE PROA' },
  { key: 'ROYAL CANIN', value: 'ROYAL CANIN', label: 'ROYAL CANIN' },
  { key: 'GABRICA', value: 'GABRICA', label: 'GABRICA' },
  { key: 'SERFIMER', value: 'SERFIMER', label: 'SERFIMER' },
  { key: 'PET PARTNERS', value: 'PET PARTNERS', label: 'PET PARTNERS' },
  { key: 'EFEVET', value: 'EFEVET', label: 'EFEVET' },
  { key: 'PURINA', value: 'PURINA', label: 'PURINA' },
  { key: 'QVET', value: 'QVET', label: 'QVET' },

])

// Form definitions
export const informationInitialValues = (information?: any) => ({
  Email: getValue(information, 'Email', ''),
  FirstName: getValue(information, 'FirstName', ''),
  LastName: getValue(information, 'LastName', ''),
  Country: getValue(information, 'Country', undefined),
  Region: getValue(information, 'Region', undefined),
  CompanyName: getValue(information, 'CompanyName', ''),
  JobTitle: getValue(information, 'JobTitle', ''),
  AgeRange: getValue(information, 'AgeRange', undefined),
  Gender: getValue(information, 'Gender', ''),
  CouponCode: getValue(information, 'CouponCode', undefined),
  Becado: getValue(information, 'Becado', ''),
  Newsletter: getValue(information, 'Newsletter', undefined),
  Voucher: getValue(information, 'Voucher', ""),
  Phone: getValue(information, 'Phone', ""),
})

export const getInformationFields = (slug?: any) => {
  const fields: Field[] = [
    {
      name: 'FirstNames',
      placeholder: 'Ej: Marcelo',
      label: i18n._('Nombres'),
      type: 'text',
      readOnly: true
    },
    {
      name: 'LastNames',
      placeholder: 'Ej: Jara',
      label: i18n._('Apellidos'),
      type: 'text',
      readOnly: true
    },
    {
      name: 'Email',
      placeholder: 'Ej: marcelo@example.com',
      label: i18n._('Correo Electrónico Principal'),
      type: 'text',
      readOnly: true
    },

    {
      name: 'Country',
      placeholder: i18n._('Por favor, seleccione su país'),
      label: i18n._('Por favor, seleccione su país'),
      type: 'select',
      options: countryOptions,
    },
    {
      name: 'Region',
      placeholder: i18n._('Por favor, seleccione su región'),
      label: i18n._('Por favor, selecciona su región'),
      type: 'select',
      options: regionOptions,
      condition: (values: Values) => values.Country === 'Chile'
    },
    {
      name: 'AgeRange',
      placeholder: i18n._('Por favor, seleccione su rango Etario'),
      label: i18n._('Rango Etario'),
      type: 'select',
      options: ageOptions
    },
    {
      name: 'Gender',
      placeholder: i18n._('Selecciona tu sexo'),
      label: i18n._('Seleccione su sexo'),
      type: 'radio',
      options: genderOptions,
      extraProps: { columns: 3 }
    },
    {
      name: 'CouponCode',
      placeholder: i18n._('Ingresa un código de cortesía'),
      label: i18n._('Código de cortesía (opcional)'),
      type: 'text'
    },
    {
      name: 'CompanyName',
      placeholder: i18n._('Ej: Clínica Reñaca'),
      label: i18n._('Nombre de su organización o empresa'),
      type: 'text'
    },
    {
      name: 'JobTitle',
      placeholder: i18n._('Ej: Gerente de TI'),
      label: i18n._('¿Cuál es su cargo?'),
      type: 'text'
    },
    {
      name: 'Becado',
      placeholder: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa?'),
      label: i18n._('¿Ha realizado su pago a alguna institución o ha sido becado por alguna empresa?'),
      type: 'select',
      options: BasicOptions,
      extraProps: { columns: 3 }
    },
    {
      name: 'Newsletter',
      placeholder: '',
      label: i18n._('Newsletter'),
      type: 'checkbox',
      options: AccepNewsletter
    },
    {
      name: 'Phone',
      placeholder: 'Ej: 912345678',
      label: i18n._('Número de Teléfono'),
      type: 'text',
    },
    {
      name: 'Region',
      placeholder: i18n._('Por favor, seleccione su región'),
      label: i18n._('Por favor, selecciona su región'),
      type: 'select',
      options: regionOptions,
      condition: (values: Values) => values.Country === 'Chile'
    },
  ]
  return fields
}

export const informationValidationSchema = yup.object().shape({
  Country: yup.string()
    .required(messages.required),
  Region: yup.string()
    .when('Country', {
      is: 'Chile',
      then: yup.string().required(messages.required),
      otherwise: yup.string().notRequired(),
    }),
  JobTitle: yup.string()
    .required(messages.required),
  CompanyName: yup.string()
    .required(messages.required),
  Gender: yup.string()
    .required(messages.required),
  AgeRange: yup.string()
    .required(messages.required),
  Role: yup.string()
    .required(messages.required),
})
